import React, { useState, useMemo } from "react";
import DLDetailsModal from "../../../Shared/SendCreate/Modals/DLDetailsModal";
import { buildDLListFromRecipients } from "../DistributionListsSection";

const RecipientsModal = ({
  isVisible,
  handlerModelCancelForSave,
  selectedLanguage,
  recipientToEmails,
  recipientCcEmails,
  recipientBccEmails,
  isRPDDL = false,
  docItem = null,
  contactGroups = [],
  contacts = [],
}) => {
  const [selectedDLForContacts, setSelectedDLForContacts] = useState(null);
  const [isDLContactsModalOpen, setIsDLContactsModalOpen] = useState(false);

  const isDL = (r) => {
    const val = r?.isDLGroup ?? r?.IsDLGroup ?? r?.isDL ?? r?.IsDL;
    return val === true || val === "true" || val === "True";
  };
  const getDLEmail = (r) => (r?.DLEmail || r?.dlEmail || r?.dlemail || "").trim();

  const isDLRecipientRecord = (r) => isDL(r) && (!getDLEmail(r) || getDLEmail(r).toLowerCase() === (r.email || r.Email || r.Address || "").trim().toLowerCase());
  const isDLMemberRecord = (r) => isDL(r) && Boolean(getDLEmail(r)) && getDLEmail(r).toLowerCase() !== (r.email || r.Email || r.Address || "").trim().toLowerCase();

  const parseRecipients = useMemo(() => {
    if (!isRPDDL || !docItem) {
      return {
        to: { dlList: [], individualEmails: "" },
        cc: { dlList: [], individualEmails: "" },
        bcc: { dlList: [], individualEmails: "" },
      };
    }

    const parseForTypes = (recipientTypes) => {
      const recps = docItem?.documentOptions?.recipients || [];
      const typeRecipients = recps.filter((r) => recipientTypes.includes(r.recipientType));

      let dls = buildDLListFromRecipients(typeRecipients, contactGroups);

      const extraDLs = (docItem.distributionLists && docItem.distributionLists.length > 0)? docItem.distributionLists: (docItem.documentOptions?.distributionLists && docItem.documentOptions.distributionLists.length > 0)? docItem.documentOptions.distributionLists: [];

      extraDLs.forEach((edl) => {
        const edlEmail = (edl.email || edl.dlEmail || edl.aliasEmail || edl.AliasEmail || "").trim().toLowerCase();
        if (edlEmail && !dls.some((d) => (d.dlEmail || d.email || "").toLowerCase() === edlEmail)) {
          dls.push({
            dlEmail: edlEmail,
            email: edlEmail,
            groupName: edl.name || edl.Name || edl.groupName || edlEmail.split("@")[0],
            name: edl.name || edl.Name || edl.groupName || edlEmail.split("@")[0],
            groupMembers: edl.groupMembers || edl.members || [],
            allowedDomains: edl.allowedDomains || edl.domains || []
          });
        }
      });

      dls.forEach((dl) => {
        const dlEmail = (dl.email || "").trim().toLowerCase();
        const matchingExtraDL = extraDLs.find((edl) => (edl.email || "").trim().toLowerCase() === dlEmail);
        const initialMembers = matchingExtraDL?.groupMembers || matchingExtraDL?.members;
        if (Array.isArray(initialMembers) && initialMembers.length > 0) {
          dl.groupMembers = initialMembers;
        } else {
          delete dl.groupMembers;
        }
      });
      const individualRecipients = typeRecipients.filter(
        (r) => !isDLRecipientRecord(r) && !isDLMemberRecord(r)
      );

      const individualEmails = individualRecipients
        .map((r) => r.email || r.Email)
        .filter(Boolean)
        .join(", ");

      return { dlList: dls, individualEmails };
    };

    return {
      to: parseForTypes(["To", "", null]),
      cc: parseForTypes(["CC"]),
      bcc: parseForTypes(["BCC"]),
    };
  }, [isRPDDL, docItem, contactGroups]);

  if (!isVisible) return null;

  const handleClose = () => {
    setIsDLContactsModalOpen(false);
    setSelectedDLForContacts(null);
    handlerModelCancelForSave();
  };

  const renderRecipientField = (parsedData, fallbackEmails, marginBottom = "0px") => {
    if (!isRPDDL) {
      return (
        <label
          className="textBoxSave"
          style={{ width: "100%", marginBottom: marginBottom }}
          readOnly
        >
          {fallbackEmails}
        </label>
      );
    }

    const { dlList = [], individualEmails = "" } = parsedData || {};

    if (dlList.length === 0 && !individualEmails) {
      return (
        <label
          className="textBoxSave"
          style={{ width: "100%", marginBottom: marginBottom }}
          readOnly
        >
          {fallbackEmails}
        </label>
      );
    }

    return (
      <div
        className="textBoxSave d-flex align-items-center flex-wrap"
        style={{
          width: "100%",
          gap: "4px",
          marginBottom: marginBottom,
          cursor: "default"
        }}
      >
        {dlList.map((dl, idx) => {
          const rawDlEmail = (dl.dlEmail || dl.email || "").trim();
          const displayDlEmail = rawDlEmail.toLowerCase().endsWith("(dl)")
            ? rawDlEmail
            : `${rawDlEmail} (DL)`;
          return (
            <span
              key={`dl-pill-${idx}`}
              className="d-inline-flex align-items-center"
              title="Click to view contacts"
              onClick={() => {
                setSelectedDLForContacts(dl);
                setIsDLContactsModalOpen(true);
              }}
              style={{
                backgroundColor: "#356fcd",
                padding: "0.25em 0.544em",
                color: "#ffffff",
                fontWeight: "600",
                border: "1px solid #356fcd",
                borderRadius: "0.18571429rem",
                fontSize: "0.9rem",
                cursor: "pointer",
                userSelect: "none",
                lineHeight: "1.2"
              }}
            >
              {displayDlEmail}
            </span>
          );
        })}
        {individualEmails && (
          <span style={{ fontSize: "14px", color: "#333", alignSelf: "center" }}>
            {dlList.length > 0 ? `, ${individualEmails}` : individualEmails}
          </span>
        )}
      </div>
    );
  };

  return (
    <>
      <div className="modalCus documentversion-history" id="myModal">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="card-body pt-1">
              <div
                className="mb-2 mt-3 justify-content-between d-flex"
                style={{ borderBottom: "2px solid #918d8d4d" }}>
                <h4 htmlFor="">
                  <p className="fw-bold" style={{ color: "#bc272e" }}>
                    {selectedLanguage.LstLanguageCodes.UI_Recipients}
                  </p>
                </h4>
                <button
                  type="button"
                  className="btn btn-outline-danger modalclose download"
                  onClick={handleClose}>
                  <span className="material-icons font-20">
                    highlight_off
                  </span>
                </button>
              </div>
              <div className="saveSettingPopupTextBox table-responsive">
                {recipientToEmails !== "" && (
                  <>
                    <div className="ToEmailsBG">
                      <span className="EmailsFont">
                        {selectedLanguage.LstLanguageCodes.UI_To}:
                      </span>
                    </div>
                    {renderRecipientField(parseRecipients.to, recipientToEmails)}
                  </>
                )}
                {recipientCcEmails !== "" && (
                  <>
                    <div className="ToEmailsBG">
                      <span className="EmailsFont">
                        {selectedLanguage.LstLanguageCodes.UI_CC}:
                      </span>
                    </div>
                    <div>
                      {renderRecipientField(parseRecipients.cc, recipientCcEmails, "7px")}
                    </div>
                  </>
                )}
                {recipientBccEmails !== "" && (
                  <>
                    <div className="ToEmailsBG">
                      <span className="EmailsFont">
                        {selectedLanguage.LstLanguageCodes.UI_BCC}:
                      </span>
                    </div>
                    <div>
                      {renderRecipientField(parseRecipients.bcc, recipientBccEmails)}
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {isDLContactsModalOpen && (
        <DLDetailsModal
          isOpen={isDLContactsModalOpen}
          onClose={() => {
            setIsDLContactsModalOpen(false);
            setSelectedDLForContacts(null);
          }}
          group={selectedDLForContacts}
          reader={selectedDLForContacts}
          contacts={contacts || []}
          contactGroups={contactGroups || []}
          contactsOnly={true}
        />
      )}
    </>
  );
};

export default RecipientsModal;
